import { TargetingApi } from 'api'
import { AxiosPromise } from 'axios'
import { omit } from 'ramda'
import {
  CampaignTargetingResult,
  ConditionalSkillEvaluationRequest,
  ServerTargetingEvaluationResults,
  TargetingEvaluationRequest,
  TargetingEvaluationRequestContext,
  WidgetImpressionRequest
} from 'types/targeting'

export const evaluateConditionalSkillTargeting = (embedId: string, evaluationRequest: ConditionalSkillEvaluationRequest) => {
  return TargetingApi.post(`conditional_skill/evaluate_conditions/${embedId}`, evaluationRequest)
}

export const fetchServerEvaluatedTargetingConditions = (evaluationRequest: TargetingEvaluationRequest, fullLog = false): AxiosPromise<ServerTargetingEvaluationResults> => {
  const payload = omit(['embedId'], evaluationRequest)
  return TargetingApi.post(`campaign-eval/retrieve_campaigns_v2/${evaluationRequest.embedId}?fullLog=${fullLog}`, payload)
}

export const postWidgetImpression = (impression: WidgetImpressionRequest) =>
  TargetingApi.post(`impressions/widget`, impression)


export const fetchOrgAvailability = (embedId: string) => {
  return TargetingApi.get(`hours/availability/combined/${embedId}`)
}

export const evaluateConditionalSkill = (payload: Record<string, any>) => {
  return TargetingApi.post(`targeting/evaluate-then/condition_skill`, payload)
}

export const persistTal = (tal: Record<string, any>) => {
  return TargetingApi.post(`targeting/evaluate_with_log`, tal)
}

interface QualifyParams {
  embedId: string,
  campaignIds: number[],
  mappingId: number
  formData: Record<string, string>,
  clientSideContext: TargetingEvaluationRequestContext,
  withMapping?: boolean
}

interface QualifyResult {
  campaignTargetingResults: CampaignTargetingResult[]
}

export const qualify = ({ embedId, campaignIds, formData, clientSideContext, mappingId, withMapping = true }: QualifyParams) =>
  TargetingApi.post<QualifyResult>(`qualify/${withMapping? 'with' : 'without'}_mapping/${embedId}`, {
    campaignIds,
    mappingId,
    formData,
    clientSideContext
  })
